export enum SizeEnum {
    small = 'is-small',
    default = '',
    medium = 'is-medium',
    large = 'is-large',
}

export type Sizes = SizeEnum.default | SizeEnum.small | SizeEnum.medium | SizeEnum.large;
